import React, { Component } from 'react';
import { Card, CardHeader, CardText, RaisedButton, FontIcon, FlatButton } from 'material-ui';
import R from 'ramda';
import moment from 'moment';

class SelectTemplates extends Component {
  constructor() {
    super();
    this.state = {
      searchInput: '',
    }
  }
  onSelect = template => () => {
    this.props.onConfirm(template);
  };
  onSearch = e => this.setState({ searchInput: e.target.value });
  render() {
    const {
      templates: templatesBeforeFilter,
      selectedTemplates = [],
      label,
      selectedComponent,
      style,
    } = this.props;
    const { searchInput } = this.state;
    const templates = searchInput
      ? templatesBeforeFilter.filter(obj => new RegExp(searchInput, 'i').test(obj.templateName)
        || new RegExp(searchInput, 'i').test(obj.locationName))
      : templatesBeforeFilter;
    const groupByLocations = R.call(R.compose(
      R.groupBy(R.prop('locationId')),
      // R.reject(template => R.any(R.eqProps('locationId', template), selectedTemplates))
    ), templates);
    const locations = {};
    templates.forEach(({ locationId, locationName }) => {
      if (!locations[locationId]) locations[locationId] = locationName;
    });
    return (
      <div style={style}>
        <input
          placeholder="Search by template name or location name..."
          value={searchInput}
          onChange={this.onSearch}
          style={{ width: '100%', marginBottom: '12px', padding: '8px' }}
        />
        {
          Object.keys(locations).map((locId, locIndex) => (
            <Card
              key={`${locIndex}${locId}`}
              initiallyExpanded
              style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}
            >
              <CardHeader
                actAsExpander
                style={{ padding: '6px' }}
                showExpandableButton
                title={<div><FontIcon className="tc-icon-location_on" color="rgba(0, 0, 0, 0.54)" />{locations[locId]}</div>}
              />
              <CardText expandable>
                {
                  groupByLocations[locId].map((template, templateIndex) => (
                    <div key={templateIndex} style={{ display: 'flex', marginLeft: '40px', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', width: '60%', height: '48px', fontSize: '14px' }}>
                        <FontIcon className="tc-icon-description" color="rgba(0, 0, 0, 0.54)" />
                        {template.templateName}
                      </div>
                      {moment(template.updatedAt).format('l')}
                      {
                        R.call(R.cond([
                          [() => selectedTemplates.some(obj => obj._id === template._id), R.always(
                            selectedComponent
                          )],
                          [R.T, R.always(
                            <RaisedButton
                              secondary
                              style={{ position: 'relative', top: '-8px' }}
                              label={label}
                              onTouchTap={this.onSelect(template)}
                            />
                          )],
                        ]))
                      }
                    </div>
                  ))
                }
              </CardText>
            </Card>))
        }
      </div>
    )
  }
}

export default SelectTemplates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/components/select-template.jsx